import { createContext, useCallback, useContext, useState } from "react";

const EnquiryContext = createContext(null);

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState("");

  const openEnquiry = useCallback((productName = "") => {
    setProduct(productName);
    setOpen(true);
  }, []);

  const closeEnquiry = useCallback(() => setOpen(false), []);

  return (
    <EnquiryContext.Provider value={{ open, product, openEnquiry, closeEnquiry }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
